import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { getConversation } from '../../../api/conversations'
import useApiCall from '../../../api/useApiCall'
import { EventEnum, MessageType } from '../../../types/conversations'
import { msToHour } from '../../../utils/time'

import ActionMessage from './ActionMessage/ActionMessage'
import BotMessage from './BotMessage/BotMessage'
import ConversationHeader from './ConversationHeader/ConversationHeader'
import UserMessage from './UserMessage/UserMessage'

import { joinClassNames } from '../../../utils/styles'
import styles from './conversation.module.scss'

interface IConversationProps {
    className: string
}

function Conversation(props: IConversationProps) {
    const { className } = props

    const { t } = useTranslation()

    const { conversationId } = useParams()

    const sectionRef = useRef<HTMLElement | null>(null)

    const [conversation, setConversation] = useState<MessageType[]>([])

    useApiCall(getConversation, setConversation, conversationId || '')

    useEffect(() => {
        if (sectionRef?.current) {
            const { children } = sectionRef.current
            children.length && children[children.length - 1].scrollIntoView()
        }
    }, [conversation])

    const renderMessage = (message: MessageType) => {
        switch (message.event) {
            case EventEnum.USER:
                return (
                    <UserMessage key={message.message_id} message={message} />
                )
            case EventEnum.ACTION:
                return (
                    <ActionMessage
                        key={`${message.timestamp}-${message.name}`}
                        message={message}
                    />
                )
            case EventEnum.BOT:
                return (
                    <BotMessage
                        key={`${message.timestamp}-${message.text}`}
                        message={message}
                    />
                )
        }
    }

    const lastTimestamp = conversation[conversation.length - 1]?.timestamp

    return (
        <section
            ref={sectionRef}
            className={joinClassNames(className, styles.conversation)}
        >
            <ConversationHeader />
            <div className={styles.conversation__messages}>
                {conversation.map((message) => renderMessage(message))}
                {lastTimestamp ? (
                    <div className={styles.conversation__leftTimestamp}>
                        <span className={styles.conversation__line} />
                        <span className={styles.conversation__leftText}>
                            {t('user_left_at')}:{' '}
                            {msToHour(
                                conversation[conversation.length - 1]?.timestamp
                            )}
                        </span>
                        <span className={styles.conversation__line} />
                    </div>
                ) : null}
            </div>
        </section>
    )
}

export default Conversation
